import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IIKOTableGridComponent } from './iiko-table-grid/iiko-table-grid.component';
import { StretchByHeightDirective } from './directives/stretch-by-height.directive';
import { PlainTableSearchStringDirective } from './directives/plain-table-search-string.directive';
import { TreeTableSearchStringDirective } from './directives/tree-table-search-string.directive';

@NgModule({
  declarations: [
    IIKOTableGridComponent,
    StretchByHeightDirective,
    PlainTableSearchStringDirective,
    TreeTableSearchStringDirective,
  ],
  imports: [CommonModule],
  exports: [
    IIKOTableGridComponent,
    StretchByHeightDirective,
    PlainTableSearchStringDirective,
    TreeTableSearchStringDirective,
  ],
})
export class IIKOTableGridModule {}
